import { Card, Box } from 'components/box';
import { Link } from 'components/configurable-routing';
import { Heading, Text } from 'components/typography';
import Button from 'components/button';
import config from '../../../util/load-config';
import { css } from '@emotion/react';
import { animated, config as springConfig, useSpring } from '@react-spring/web';
import { useEffect, useState } from 'react';
import { zIndices } from 'constants/z-indices';

const Popup = ({ dismiss }: { dismiss: () => void }) => {
  const [open, setOpen] = useState(false);
  const styles = useSpring({
    bottom: open ? 0 : -400,
    config: springConfig.gentle,
  });

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <animated.div
      style={styles}
      css={css`
        position: fixed;
        right: 0;
        z-index: ${zIndices.APP_NOTIFICATIONS};
      `}
    >
      <Box width={['100%', '300px']}>
        <Card
          mx={3}
          mb={[3, 0]}
          borderRadius={3}
          css={theme => css`
            @media ${theme.mediaQueries.tabletUp} {
              border-radius: 16px 16px 0 0;
            }
          `}
        >
          <Heading
            color="black"
            fontWeight={700}
            lineHeight={1.3}
            letterSpacing={0.1}
            fontSize={2}
          >
            Cookies: nom nom nom.
          </Heading>

          <Text color="black" lineHeight={1.2} fontSize={2} my={2}>
            Heads up: The cookies we use are there to give you a better user
            experience and to allow us to analyse what&apos;s working and what
            isn&apos;t. We&apos;re telling you all this, since your continued
            use of our website implies your consent to the use of these cookies
            in accordance with our{' '}
            <Link
              target="_blank"
              href={config.helpCentreLinks.privacyPolicy}
              fontWeight={500}
              prefetch={false}
            >
              Privacy Policy
            </Link>
          </Text>

          <Button
            mt={3}
            width="100%"
            onClick={() => {
              setOpen(false);
              dismiss();
            }}
          >
            Got it
          </Button>
        </Card>
      </Box>
    </animated.div>
  );
};

export default Popup;
